import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useUser } from 'context/UserContext'
import { ButtonWrapper } from 'components/ButtonWrapper'
import { ChoiceButton } from 'components/ChoiceButton'
import { Heading } from 'components/Heading'

interface Props {
  nextRoute: string
}

export const ExerciseTime: React.FC<Props> = ({ nextRoute }) => {
  const { t } = useTranslation('translation', {
    useSuspense: false,
  })

  const navigate = useNavigate()
  const { user } = useUser()
  const genderBasedBackground =
    user.gender === 'm'
      ? 'bg-exercise-time-male bg-center'
      : 'bg-exercise-time-female bg-center'

  const onButtonClick = () => {
    navigate(nextRoute)
  }

  return (
    <div className={`default-container ${genderBasedBackground} flex flex-col`}>
      <div className="flex h-full flex-col justify-between self-center overflow-auto px-7 pb-10 pt-7 lg:w-5/6 xl:w-5/12">
        <div className="flex flex-col gap-y-2">
          <Heading text={t('exercise_time.headline')} />
          <p className="font-body text-sm text-white xl:text-center">
            {t('exercise_time.subheadline')}
          </p>
        </div>

        <ButtonWrapper>
          <ChoiceButton
            onClick={onButtonClick}
            value={t('exercise_time.option_1')}
            id="option_1"
          />
          <ChoiceButton
            onClick={onButtonClick}
            value={t('exercise_time.option_2')}
            id="option_2"
          />
          <ChoiceButton
            onClick={onButtonClick}
            value={t('exercise_time.option_3')}
            id="option_3"
          />
        </ButtonWrapper>
      </div>
    </div>
  )
}
